let stropheConnection = require("./stropheConnection.js");
let timeFormat = require("./timeformat.js");
let utils = require("./utils.js");
let recentdesign = require("./recentdesign.js");
let anchorme = require("anchorme").default;
let userprofile = require("./userprofile.js");
let storage = require("./storage.js");
let groups = require("./groups.js");
const vCard = require("./vCard.js");
let language = require('./locale/language.js');
let broadcastProfilePage = require('./broadcastProfile.js')
const webEncrypt  = require('./webchatEncryptDecrypt.js');

let recentListCount = 0;
let shouldHandleScroll,msgcontent;

module.exports = {
  toJID: function () {
    return webEncrypt.getFromLocalStorageAndDecrypt('toJID');
  },
  getRecentChat: function (sideBarIdName,page,searchVal) {
    let searchTxt = encodeURIComponent(searchVal);
    let defaultCount = language.locali().default_recent_chat_pagination;
    let recentUrl = window._env_.ApiURL + "/users/chat/recent"+ '?page=' + page+ '&size='+defaultCount+ '&search='+searchTxt;

    $.ajax({
      url: recentUrl,
      type: 'GET',
      dataType: 'json',
      cache: false,
      contentType: false,
      processData: false,
      async: false,
      crossDomain: true,
      headers: {
          'authorization': storage.getuserToken()
      },
      statusCode: {
          401: function (response) {
              console.log('Security Token Error');
              let loginUserInfo = webEncrypt.getFromLocalStorageAndDecrypt('loginUserInfo');
              let username = loginUserInfo[0][0];
              contactStorage.setSession(username)
              module.exports.getContacts(conQueryParams)
          },
          500: function (response) {
              console.log('Internal Server Error');
          }
      },
      success: function (response) {
        let data = response.data;
        let elementName = sideBarIdName;
        let elementId = "#"+elementName;
        let totalRecords = response.totalRecords;
        if(page == 1 || page == ''){
          $(elementId).find('.recentcontent').remove()

        }
        if(data.length >0){

        module.exports.enableScrollHandler();

        module.exports.getRecentChatCallBack(data)
          
        module.exports.getRecentCustomScrollBarset(page,elementId,elementName,totalRecords);

        // if(searchVal != ''){
        //   module.exports.searchTextContentnotEmpty(searchVal);
        // }

      }else {
        $(elementId).mCustomScrollbar("destroy");
        $("#sideBar").children().remove()
        $("#sideBar").html("<div id='norecent'>No recent chat available</div>");
      }


      },
      error: function (jqXHR, exception) {
          utils.errorMsgHandling(jqXHR, exception)

      },
      complete: function(){
        $('.loader').css("display", "none");
        utils.commonHeaderTitleUpdate()
      }
  });

  },

  searchTextContentnotEmpty: function(content){
    $("#recentcontent").children().hide();
    $("#rostersidebar").children().hide();
    $("#rostersidebar").show();
    $("#recentcontent").prepend("<div id='norecentcontent'>" + language.locali().no_chats_contacts_messages_found + "</div>");
    $(".searchOpen").hide();
    $("#searchClose").show();
    $("#searchClose").css('display', 'flex');
  
    $("#rostersidebar").find('.sideBar-body').each(function () {
      let rosterval = $(this).find('.name-meta').text().toUpperCase();
      let searchtxt = content.toUpperCase();
      if (rosterval.indexOf(searchtxt) != -1) {
        $("#norecentcontent").remove();
        // remove any old highlighted terms
        $(this).find('.name-meta').removeHighlight();
        $(this).find('.name-meta').highlight(searchtxt);
        $(this).show();
      }
    });
  
    $("#recentcontent").find('.recentcontent').each(function () {
      let recentval = $(this).find('.name-meta').text().toUpperCase();
      let searchtxt = content.toUpperCase();
      if (recentval.indexOf(searchtxt) != -1 ) {
        $("#norecentcontent").remove();
        // remove any old highlighted terms
        $(this).find('.name-meta').removeHighlight();
        $(this).find('.name-meta').highlight(searchtxt);
        $("#rostersidebar").find("[id='rostersearch-"+$(this).attr('id')+"']").hide();
        $(this).show();
      }
    });
  

  },

  convertTimeFormat: function (timestamp){
      // Convert it to a Date object
      const date = new Date(timestamp);

      // Extract hours and minutes
      let hours = date.getHours();
      const minutes = date.getMinutes();

      // Determine AM or PM
      const ampm = hours >= 12 ? 'PM' : 'AM';

      // Convert hours to 12-hour format
      hours = hours % 12;
      hours = hours ? hours : 12; // The hour '0' should be '12'

      // Format minutes to always be two digits
      const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;

      // Combine to get the final format
      const formattedTime = `${hours}:${formattedMinutes} ${ampm}`;

      return formattedTime;
  },

  getRecentPriorityMsgCount : function(userOrGrpIds){

    let priortiMsgCountIQ = stropheConnection.StropheJs().$iq({
            type: 'get',
            id: utils.getId(),
            to: stropheConnection.Server()
        }).c('query', {
            xmlns: 'jabber:iq:user_activities',
            users: userOrGrpIds,
            status: "get_priority_exists",
        });
        if (stropheConnection.Connection().connected) {
            stropheConnection.Connection().sendIQ(priortiMsgCountIQ, module.exports.getRecentPriorityCallBack);
        }
  },

  getRecentPriorityCallBack: function(priortiMsgCountIQ){
    try {
      let usersPriorityInfo = webEncrypt.getFromLocalStorageAndDecrypt('usersPriorityInfo');

      if ($(priortiMsgCountIQ).find('user').length != 0) {
        
        $(priortiMsgCountIQ).find('user').each(function (index) {
          
          if($(this).attr("count") > 0) {
            let id = $(this).text();
            let count = $(this).attr('count');
            let messageContent = $('#'+id).find('.name-status').html();
            let priorityContent = "<span class='priority-message-recent'>PRIORITY</span>";
            if(!$('#'+id).find('.name-status').children().first().hasClass('priority-message-recent')){

              $('#'+id).find('.name-status').html(priorityContent + '  '+ messageContent);
            }
            if(!$('#forwardcontact-'+id).find('.name-status').children().first().hasClass('priority-message-recent')){

              $('#forwardcontact-'+id).find('.name-status').html(messageContent);
            }
            if(usersPriorityInfo != null){
              usersPriorityInfo[id] = [];
              usersPriorityInfo[id][1] = count;
              console.log("priortiMsgCountIQ : ",$(this)[0])
            }
           
          }
          
  
        })

        webEncrypt.encryptAndStoreInLocalStorage('usersPriorityInfo', usersPriorityInfo);        
                   

      }
    } catch (error) {
        console.log("get Priority Error : ",error)
    }
    
  },

  getRecentChatCallBack: function (recentChatData) {
    try{
    let mediaUrl = window._env_.ApiURL + "/media/";
    webEncrypt.deleteItemFromLocalStorage('usersPriorityInfo');
    let usersPriorityInfo = {};
    let userToken = storage.getuserToken();
    $(".loader").css("display", "none");
    let userJID = stropheConnection.logininfo.userJID.toLowerCase();
          
    $("#forwardcontact").mCustomScrollbar("destroy");
    document.title = "Ikonix Connect";
    let userInfo = webEncrypt.getFromLocalStorageAndDecrypt('usersProfileInfo');
    let groupInfo = webEncrypt.getFromLocalStorageAndDecrypt('groupProfile')
    let broadcastProfile = webEncrypt.getFromLocalStorageAndDecrypt('broadcastProfile');
    
    let blockListUserInfo = webEncrypt.getFromLocalStorageAndDecrypt('blockListUserInfo');
    let blockUserInfo = webEncrypt.getFromLocalStorageAndDecrypt('blockUserInfo');
    
    let userAndGrpIds = [];
      if (typeof recentChatData !== 'undefined' && recentChatData.length > 0) {
        $("#norecent").remove();
        $("#norecentcontent").remove();
        $('#norecent').hide();
        $('#sideBar #norecent').hide();
        for (let keys in recentChatData) {
          let recentChat  = recentChatData[keys];

          let botType             = recentChat.chatType;
          let msgfrom             = recentChat.fromUser;
          let formattedTimestamp = recentChat.createdAt.replace('T', ' ');
          let time                = timeFormat.convertTimestamp(formattedTimestamp, "recent_at");
          let status              = recentChat.status;
          let msgid               = recentChat.messageId;
          let msgto               = recentChat.toUser;
          let msgbody             = recentChat.txt;
          let publisher           = recentChat.fromUser;
          let chattype            = recentChat.chatType;
          let deletedstatus       = '';
          let deletedby           = '';
          let chatdeletedstatus   = '';
          let chatdeletedby       = '';
          let blockedby           = '';
          let unReadCount         = recentChat.unread;
          let msg_ack             = recentChat.msgAck;
          let ack_status          = recentChat.ackStatus;
          let msgConvFrom         = recentChat.messageFrom;
          let msgConvTo           = recentChat.messageTo;
          let recallstatus        = recentChat.recallStatus;
          let broadcastmsg_id     = recentChat.broadcastMsgId;
          let messageType         = recentChat.messageType;
          let notificationTo      = recentChat.notificationTo;
          let messageFromId       = recentChat.messageFromId;
          
          let priorityCount       = 0;
          let noAckPriorityCount  = 0;
          let name,tempname,profileimage,image,messageid,statusImage,messageBodyContent,receiptStatus,ackStatus,recentChatMsgFrom='';
          if (msgfrom == userJID) {
            tempname = msgto.toLowerCase();
          } else {
            tempname = msgfrom.toLowerCase();
          }
          if(botType != 'broadcast'){

            userAndGrpIds.push(msgfrom)
          }

    
          if (groupInfo != null && typeof groupInfo[tempname] != "undefined") {
            profileimage = groupInfo[tempname][2];
            if (utils.getHexRegexPattern().test(profileimage)) {
              image = profileimage;
            } else if (profileimage !== "src/images/avatar/group/group_four.svg" && profileimage.trim() !== "") {
              image = mediaUrl + profileimage + "?mf=" + userToken;
            } else if (profileimage.trim() == "") {
              image = "src/images/avatar/group/group_four.svg";
            } else {
              image = profileimage;
            }
    
            name = groupInfo[tempname][1];
            messageid = msgid;
          } else if (userInfo != null && typeof userInfo[tempname] != "undefined") {
            profileimage = userInfo[tempname][2];
              if (utils.getHexRegexPattern().test(profileimage)) {
                image = profileimage;
              } else if (typeof profileimage != 'undefined' && profileimage !== "src/images/avatar/chat/profile_img_one.svg" && profileimage.trim() !== "") {
                image = mediaUrl + profileimage + "?mf=" + userToken;
              } else if (typeof profileimage === 'undefined' || profileimage.trim() == "") {
                image = "src/images/avatar/chat/profile_img_one.svg";
              } else {
                image = profileimage;
              }
            name = userInfo[tempname][1];
            messageid = msgid;
          } else if (broadcastProfile != null && typeof broadcastProfile[tempname] != "undefined") {
            profileimage = broadcastProfile[tempname][2];
            
            if (profileimage !== "src/images/avatar/broadcast/profile_img_one.png" && profileimage.trim() !== "") {
              image = mediaUrl + profileimage + "?mf=" + userToken;
            } else if (profileimage.trim() == "") {
              image = "src/images/avatar/broadcast/profile_img_one.png";
            } else {
              image = profileimage;
            }
            name = broadcastProfile[tempname][1];
            messageid = msgid;
          } else if (tempname != userJID) {
    
            if (chattype == "chat") {
              if (userInfo == null) {
                userInfo = {};
              }
              userInfo[tempname] = [];
              userInfo[tempname].push("chat");
              userInfo[tempname].push(tempname);
              userInfo[tempname].push("src/images/avatar/chat/profile_img_one.svg");
              userInfo[tempname].push(language.locali().default_status);
              webEncrypt.encryptAndStoreInLocalStorage('usersProfileInfo', userInfo)
              image = "src/images/avatar/chat/profile_img_one.svg";
              userprofile.getUserProfile(tempname);
              vCard.getVcard(tempname + "@" + stropheConnection.Server());
          
            } else {
                groups.getGroup(tempname);
            }
            
            name = tempname;
            messageid = msgid;
    
          }
          
          if (msgid == 0 || messageType == 'notification') {
            if (chattype == "chat" || chattype == "broadcast") {
              if (broadcastProfile != null && typeof broadcastProfile[msgfrom] != "undefined") {
                msgcontent = utils.broadcastNotificationLablestatus(msgbody, msgConvTo);

                profileimage = broadcastProfile[msgfrom][2];
                if (profileimage !== "src/images/avatar/broadcast/profile_img_one.png" && profileimage.trim() !== "") {
                  image = mediaUrl + profileimage + "?mf=" + userToken;
                } else if (profileimage.trim() == "") {
                  image = "src/images/avatar/broadcast/profile_img_one.png";
                } else {
                  image = profileimage;
                }
                name = broadcastProfile[msgfrom][1];
                messageid = msgid;
                statusImage = "";
              } else {
                msgcontent = "";
                statusImage = "";
              }
    
            } else if (chattype == "normal") {

              msgcontent = utils.groupstatus(msgfrom, messageFromId, notificationTo, msgbody, msgConvFrom, msgConvTo);
              statusImage = "";
              if(priorityCount > 0 || noAckPriorityCount > 0) {
                usersPriorityInfo[tempname] = [];
                usersPriorityInfo[tempname][0] = parseInt(noAckPriorityCount);
                usersPriorityInfo[tempname][1] = parseInt(priorityCount);
                if(msgbody == 3 && status == userJID) {
                  // user removed from the group
                } else {
                  msgcontent = '<span class="priority-message-recent">PRIORITY</span>' + msgcontent;
                } 
              }
            }
          } else {
            if (botType == "chat" || botType == "broadcast") {
              msgcontent = "";
              try {
                
                let decryptedMsg = utils.decrypt(msgbody, msgid);
                let msgContent = (decryptedMsg && decryptedMsg != '') ? JSON.parse(decryptedMsg) : '';
                
                recentChatMsgFrom = msgContent.message_from;
                if(priorityCount > 0 || noAckPriorityCount > 0) {
                  usersPriorityInfo[tempname] = [];
                  usersPriorityInfo[tempname][0] = parseInt(noAckPriorityCount);
                  usersPriorityInfo[tempname][1] = parseInt(priorityCount);
                  messageBodyContent = utils.checkMessageType(msgContent, msgid, 2);
                } else {
                  messageBodyContent = utils.checkMessageType(msgContent, msgid);
                }
                msgcontent = messageBodyContent[0];
              }catch (err){
                console.log(err);
                msgcontent = "";
              }
            } else {
              try {
                
                let decryptedMsg = utils.decrypt(msgbody, msgid);
                let msgContent = (decryptedMsg && decryptedMsg != '') ? JSON.parse(decryptedMsg) : '';
                let msgIcon = module.exports.getGroupChatRecentIcon(messageType);
               
                msgbody = module.exports.getGroupchatRecentMsgBody(msgContent,msgbody,messageType,decryptedMsg)
                msgcontent = msgIcon + anchorme(minEmoji(msgbody), {
                  attributes: [
                    function (urlObj) {
                      if (urlObj.protocol !== "mailto:")
                        return { name: "target", value: "blank" };
                    }
                  ]
                }) ;
              } catch (err){
                console.log(err);
                msgcontent = "";
              }
            }
    
            if (chattype == "chat") {
              if ((userInfo != null && typeof userInfo[tempname] != "undefined")) {

                if (messageFromId == userJID) {
    
                  if (recallstatus == 1) {
                    if(priorityCount > 0 || noAckPriorityCount > 0) {
                      msgcontent = "<span class='priority-message-recent'>PRIORITY</span><i class='text-italic icon-name-status'> <span class='inner-msg-txt'> You deleted this message</span></i>";
                    } else {
                      msgcontent = "You deleted this message";
                    }
                    statusImage = "";
                  } else {
                    if (status == 1) {
                      receiptStatus = "<span class='receiptStatus'>Delivered</span>";
                    } else if (status == 2) {
                      receiptStatus = "<span class='receiptStatus'>Read</span>";
                    } else if (status == 0) {
                      receiptStatus = "<span class='receiptStatus'>Sent</span>";
                    }
    
                    if (msg_ack == 1) {
                      if (ack_status == 1) {
                        ackStatus = "<span class='ackStatus'>Acknowledged</span>";
                      } else {
                        ackStatus = "<span class='ackStatus'>Ack Pending</span>";
                      }
                    } else if (msg_ack == 2) {
                      if (ack_status == 1) {
                        ackStatus = "<span class='ackStatus'>Accepted</span>";
                      } else if (ack_status == 2) {
                        ackStatus = "<span class='ackStatus'>Rejected</span>";
                      } else {
                        ackStatus = "<span class='ackStatus'>Acc/Rej Pending</span>";
                      }
                    } else {
                      ackStatus = "";
                    }
    
                    if (ackStatus == "") {
                      statusImage = receiptStatus;
                    } else {
                      statusImage = receiptStatus + ', ' + ackStatus;
                    }
                  }
                } else {
                  if (recallstatus == 1 && msgcontent != "") {
                    if(priorityCount > 0 || noAckPriorityCount > 0) {
                      msgcontent = "<span class='priority-message-recent'>PRIORITY</span><i class='text-italic icon-name-status'> <span class='inner-msg-txt'> This message was deleted</span></i>";
                    } else {
                      msgcontent = "This message was deleted";
                    }
                  }
                  if (msg_ack == 1) {
                    if (ack_status == 1) {
                      ackStatus = "<span class='ackStatus'>Acknowledged</span>";
                    } else {
                      ackStatus = "<span class='ackStatus'>Ack Pending</span>";
                    }
                  } else if (msg_ack == 2) {
                    if (ack_status == 1) {
                      ackStatus = "<span class='ackStatus'>Accepted</span>";
                    } else if (ack_status == 2) {
                      ackStatus = "<span class='ackStatus'>Rejected</span>";
                    } else {
                      ackStatus = "<span class='ackStatus'>Acc/Rej Pending</span>";
                    }
                  } else {
                    ackStatus = "";
                  }
                  
                  statusImage = (ackStatus != '') ? ackStatus : '';
                }
              }
            } else if (chattype == "normal") {

              if (groupInfo != null && typeof groupInfo[tempname] != "undefined") {
                receiptStatus = "<span class='receiptStatus'>Del'd <span class='deliveredCount'>0</span> of <span class='totalMembers'>0</span>, Read <span class='readCount'>0</span> of <span class='totalMembers'>0</span></span>";
    
                if(publisher == userJID) {
                  if (recallstatus == 1 && msgcontent != "") {
                    if(priorityCount > 0 || noAckPriorityCount > 0) {
                      msgcontent = "<span class='priority-message-recent'>PRIORITY</span><i class='text-italic icon-name-status'><span class='inner-msg-txt'> You deleted this message</span></i>";
                    } else {
                      msgcontent = "You deleted this message";
                    }
                    statusImage = "";
                  } else {
    
                    if (msg_ack == 1) {
                      ackStatus = "<span class='ackStatus'>Ack'd <span class='acknowledgeCount'>0</span> of <span class='totalMembers'>0</span></span>";
                    } else if (msg_ack == 2) {
                      ackStatus = "<span class='ackStatus'>(Acc'd <span class='acceptCount'>0</span>, Rej'd <span class='rejectCount'>0</span>) of <span class='totalMembers'>0</span></span>";
                    } else {
                      ackStatus = "";
                    }
    
                    if (ackStatus == "") {
                      statusImage = receiptStatus;
                    } else {
                      statusImage =  receiptStatus +', '+ ackStatus;
                    }
                  }
                } else {
    
                  if (recallstatus == 1 && msgcontent != "") {
                    if(priorityCount > 0 || noAckPriorityCount > 0) {
                      msgcontent = "<span class='priority-message-recent'>PRIORITY</span><i class='text-italic icon-name-status'><span class='inner-msg-txt'> This message was deleted</span></i>";
                    } else {
                      msgcontent = "This message was deleted";
                    }
                  } 
                  statusImage = "";
                }
                utils.getGroupMsginfo(messageid, tempname + "@mix." + stropheConnection.Server());
              } else {
                statusImage = "";
              }
            } else if (chattype == "broadcast") {
              if (msgfrom != "") {
                tempname = msgfrom;
                if (broadcastProfile != null && typeof broadcastProfile[msgfrom] != "undefined") {
                    receiptStatus = "<span class='receiptStatus'>Del'd <span class='deliveredCount'>0</span> of <span class='totalMembers'>0</span>, Read <span class='readCount'>0</span> of <span class='totalMembers'>0</span></span>";
      
                    if (recallstatus == 1 && msgcontent != "") {
                      if(priorityCount > 0 || noAckPriorityCount > 0) {
                        msgcontent = "<span class='priority-message-recent'>PRIORITY</span><i class='text-italic icon-name-status'><span class='inner-msg-txt'> You deleted this message</span></i>";
                      } else {
                        msgcontent = "You deleted this message";
                      }
                      statusImage = "";
                    } else {
      
                      if (msg_ack == 1) {
                        ackStatus = "<span class='ackStatus'>Ack'd <span class='acknowledgeCount'>0</span> of <span class='totalMembers'>0</span></span>";
                      } else if (msg_ack == 2) {
                        ackStatus = "<span class='ackStatus'>(Acc'd <span class='acceptCount'>0</span>, Rej'd <span class='rejectCount'>0</span>) of <span class='totalMembers'>0</span></span>";
                      } else {
                        ackStatus = "";
                      }
      
                      if (ackStatus == "") {
                        statusImage = receiptStatus;
                      } else {
                        statusImage =  receiptStatus +', '+ ackStatus;
                      }
                    }
                  if (status != 4) {

                    let id = utils.randomString(16, 'a#');
                    broadcastProfilePage.getBroadcastMsginfo(broadcastmsg_id,stropheConnection.Server(),id);
                  }

                }
              }
            } else {
              statusImage = "";
            }
            messageid = msgid;
            status = (status != 4) ? statusImage : status ;

          }
          if (status == 4) {
            msgcontent = "";
            statusImage = "";
            messageid = "";
          }

            if (blockListUserInfo != null && typeof blockListUserInfo[tempname] != "undefined") {
              image = "src/images/avatar/chat/profile_img_one.svg";
              if (userInfo != null && typeof userInfo[tempname] != "undefined") {
                userInfo[tempname][2] = image;
                userInfo[tempname][3] = language.locali().default_status;
                webEncrypt.encryptAndStoreInLocalStorage('usersProfileInfo', userInfo)
              }
            }
    
            if (blockUserInfo != null && typeof blockUserInfo[tempname] != "undefined") {
              msgcontent = "";
              statusImage = "";
              time = "";
              messageid = "";
            }
            if ((deletedstatus == 1 && deletedby == userJID) || blockedby == msgto || deletedstatus == 2 ) {
              msgcontent = "";
              statusImage = "";
              time = "";
              messageid = "";
            }
    
            if ((chatdeletedstatus == 1 && chatdeletedby == userJID) || blockedby == msgto || chatdeletedstatus == 2 ) {
              //deleted chat
            } else {
              let msgStatusImage = statusImage;
              let recentChatObj = {
                nodeJid       :tempname,
                name          :name,
                image         :image,
                msgcontent    :msgcontent,
                time          :time,
                status        :msgStatusImage,
                messageid     :messageid,
                unReadCount   :unReadCount,
                tstatusImage  :"",
                updateRecent  :0,
                recentChatMsgFrom:recentChatMsgFrom,
                messageType   : messageType,
              }

              recentdesign.recentchatcontent(recentChatObj);
            }
        
      
        }
        if(userAndGrpIds.length > 0){
          userAndGrpIds = userAndGrpIds.join(',');
          module.exports.getRecentPriorityMsgCount(userAndGrpIds)

        }

        
        webEncrypt.encryptAndStoreInLocalStorage('usersPriorityInfo', usersPriorityInfo);        

          recentdesign.RecentChatDesign();
          recentdesign.recentdropdownClick();

          $(".heading-dot").show();
      }
      
  } catch (err) {
    console.log("Recent chat callback Handler", err);
  }
    return true;
  },

  /** Oncall Units Append and Scroll bar update **/
   getRecentCustomScrollBarset: function(page,elementId,elementName,totalRecords){
    console.log("elementId : ",elementId)
    if (page == 1 || page == "") {

      $(elementId).mCustomScrollbar("destroy");

        $(elementId).mCustomScrollbar({
            scrollInertia: false,
            callbacks: {
              onTotalScroll: function(){
                   console.log("Scrolling!!!!!")
                    if (!shouldHandleScroll) {// Skip Or Stop Scroll event After Reach Last Element
                        return; // Skip handling the event if the flag is false
                    }

                    let container = $(this);
                    let scrollTop = container.scrollTop(); // Current scroll position

                    let containerTop = container.offset().top;
                    let containerHeight = container.height();

                    let targetElement = $('.recentcontent').last();
                    
                    if(targetElement.length > 0){
                        let elementTop = targetElement.offset().top - containerTop-300;

                        // Calculate the bottom position of the container
                        let scrollBottom = scrollTop + containerHeight;

                        if (scrollBottom >= elementTop) {
                            console.log('Scroll reached target element!!!!!!!');
                            let sideBarIdName = elementName;
                            let searchVal = $('#searchText').val()
                            let recentCount = $('.recentcontent').length;
                            let rolesLength = recentCount / language.locali().default_recent_chat_pagination;
                            page = rolesLength + 1;

                            module.exports.unitBasedRecentRecordsScrollHandling(recentCount,sideBarIdName,page,searchVal,totalRecords);
                            

                            $(elementId).mCustomScrollbar('update')
                            
                            // Perform actions here when scroll reaches the element
                        }
                    }
                
                },
               
            }
        });
    } 
  },

   /** Function to disable the event handler **/
   disableScrollHandler:function() {
    shouldHandleScroll = false;
  },

  /** Function to enable the event handler **/
  enableScrollHandler:function() {
      shouldHandleScroll = true;
  },

  unitBasedRecentRecordsScrollHandling(rolesCount,sideBarIdName,page,searchVal,totalRecords){
    console.log("arolesCount : ",rolesCount)
    if(totalRecords == rolesCount){
      module.exports.disableScrollHandler();

    }else {
      if (rolesCount % language.locali().default_recent_chat_pagination == 0) {
        module.exports.getRecentChat(sideBarIdName,page,searchVal);

      }else {
          module.exports.disableScrollHandler();
      }
    }


  },

  getGroupchatRecentMsgBody: function(msgContent,msgbody,messageType,decryptedMsg){
    let validImageTypes = ["video","audio","image","file","auto_text","contact","location"]
    if($.inArray(messageType, validImageTypes) >= 0 ){
      if(messageType == 'image'){
        messageType = 'Photo';
      }
      msgbody = messageType.charAt(0).toUpperCase()+ messageType.slice(1);;

    }else {

      msgContent = (decryptedMsg && decryptedMsg != '') ? JSON.parse(decryptedMsg) : '';
      msgbody = (msgContent) ? msgContent.message : '';
    }

    return msgbody;
  },

  getGroupChatRecentIcon: function(messageType){
    let msgIcon;
    switch (messageType) {
      case 'video':
          msgIcon = "<i class='video-file text-italic'></i>";
          break;
      case 'audio':
          msgIcon = "<i class='microphone text-italic'></i>";
          break;
      case 'image':
          msgIcon = "<i class='cam-ico text-italic'></i>";
          break;
      case 'file':
        msgIcon = "<i class='text-italic'></i>";
        break;
      case 'contact':
        msgIcon = "<i class='text-italic'></i>";
        break;
      case 'location':
        msgIcon = "<i class='text-italic'></i>";
        break;
      default:
        msgIcon = "";
        break;
  }

  return msgIcon;
  }
  
};
